var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collect',{attrs:{"title":"確認テスト","offset":0,"contents":_vm.contents}})}
var staticRenderFns = []

export { render, staticRenderFns }